<script>
/**
 * ResponsiveCards
 * ---------------------------------------------------------------------------
 * Replica el patrón "doble render" (tabla en desktop / cards en móvil) de los
 * sistemas de referencia, adaptado a Vue 2 + Bootstrap 5.
 *
 * Se muestra en móvil y tablet (< lg / 992px) vía `d-lg-none`. En desktop la
 * tabla (vuetable / b-table) se mantiene, envuelta en `d-none d-lg-block`.
 *
 * NO altera datos ni lógica: recibe los `items` (las filas de la página, que
 * los listados ya guardan en `this.items = paginationData.data`) y delega el
 * diseño de cada card al slot `#card`, donde cada vista reusa sus propios
 * formatters/acciones.
 *
 * Uso:
 *   <ResponsiveCards :items="items">
 *     <template #card="{ item }">
 *       ...anatomía de la card (badges+acciones / título / valor / metadatos)...
 *     </template>
 *   </ResponsiveCards>
 */
export default {
  name: "ResponsiveCards",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: "Sin registros para mostrar.",
    },
  },
};
</script>

<template>
  <div class="rwd-cards d-lg-none">
    <div v-if="!items || items.length === 0" class="rwd-cards__empty">
      {{ emptyText }}
    </div>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="rwd-card"
    >
      <slot name="card" :item="item" :index="index" />
    </div>
  </div>
</template>

<style scoped>
.rwd-cards {
  display: block;
}
.rwd-card {
  border: 1px solid #e7e9ef;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.8rem 0.9rem;
  box-shadow: 0 1px 3px rgba(16, 42, 76, 0.06);
  margin-bottom: 0.6rem;
}
.rwd-cards__empty {
  text-align: center;
  color: #8a909c;
  padding: 1.5rem;
}
</style>
